import { lazy } from "react";
import { ONLINE_ORDERS_ENABLED } from "@/constants/features";
import { RouteConfig } from "./types";

// Lazy load page components for better performance
const AppointmentScheduler = lazy(
  () => import("../pages/AppointmentScheduler"),
);
const ClientProfile = lazy(() => import("../pages/Clients/ClientProfile"));
const EditClient = lazy(() => import("../pages/Clients/EditClient"));
const NewClient = lazy(() => import("../pages/Clients/NewClient"));
const PetProfile = lazy(() => import("../pages/Clients/PetProfile"));
const SearchResults = lazy(() => import("../pages/Clients/SearchResults"));
const Clients = lazy(() => import("../pages/Clients/Clients"));
const CreateBookingPage = lazy(
  () => import("../pages/Booking/CreateBookingPage"),
);
const EditBookingPage = lazy(() => import("../pages/Booking/EditBookingPage"));
const SalePage = lazy(() => import("../pages/Booking/SalePage"));
const BudgetPage = lazy(() => import("../pages/Booking/BudgetPage"));
const AddPet = lazy(() => import("../pages/Clients/AddPet"));
const Backoffice = lazy(() => import("../pages/Backoffice"));
const Communications = lazy(() => import("../pages/Communications"));
const Metrics = lazy(() => import("../pages/Metrics"));
const Reports = lazy(() => import("../pages/Reports"));
const EmployeeServices = lazy(() => import("../pages/EmployeeServices"));
const Healthboxes = lazy(() => import("../pages/Healthboxes"));
const Banners = lazy(() => import("../pages/Content/Banners"));
const ContentPages = lazy(() => import("../pages/Content/ContentPages"));
const News = lazy(() => import("../pages/Content/News"));
const EditPet = lazy(() => import("../pages/Clients/EditPet"));
const OnlineOrders = lazy(() => import("../pages/OnlineOrders"));

export const routes: RouteConfig[] = [
  {
    path: "/",
    element: AppointmentScheduler,
    title: "Dashboard",
    icon: "dashboard",
  },
  {
    path: "/atendimento",
    element: CreateBookingPage,
    title: "Criar Agendamento",
  },
  {
    path: "/atendimento/:appointmentId",
    element: EditBookingPage,
    title: "Editar Agendamento",
  },
  {
    path: "/venda/:saleId?",
    element: SalePage,
    title: "Venda",
  },
  {
    path: "/orcamento/:budgetId?",
    element: BudgetPage,
    title: "Orcamento",
  },
  /* Off, the path falls through to the catch-all and lands on the dashboard. */
  ...(ONLINE_ORDERS_ENABLED
    ? [
        {
          path: "/encomendas-online",
          element: OnlineOrders,
          title: "Encomendas Online",
        },
      ]
    : []),
  {
    path: "/backoffice",
    element: Backoffice,
    title: "Backoffice",
  },
  {
    path: "/backoffice/comunicacoes",
    element: Communications,
    title: "Comunicações",
  },
  {
    path: "/backoffice/metricas",
    element: Metrics,
    title: "Métricas",
  },
  {
    path: "/backoffice/relatorios",
    element: Reports,
    title: "Relatórios",
  },
  {
    path: "/backoffice/servicos-colaboradores",
    element: EmployeeServices,
    title: "Serviços por colaborador",
  },
  {
    path: "/backoffice/healthboxes",
    element: Healthboxes,
    title: "Healthboxes",
  },
  {
    path: "/backoffice/conteudos/banners",
    element: Banners,
    title: "Banners",
  },
  {
    path: "/backoffice/conteudos/paginas",
    element: ContentPages,
    title: "Páginas",
  },
  {
    path: "/backoffice/conteudos/noticias",
    element: News,
    title: "Notícias",
  },
  {
    path: "/clientes",
    element: Clients,
    title: "Clientes",
    icon: "clients",
  },
  {
    path: "/clientes/pesquisa",
    element: SearchResults,
    title: "Resultados da Pesquisa",
  },
  {
    path: "/clientes/novo",
    element: NewClient,
    title: "Novo Cliente",
  },
  {
    path: "/clientes/:id",
    element: ClientProfile,
    title: "Perfil do Cliente",
  },
  {
    path: "/clientes/:id/editar",
    element: EditClient,
    title: "Editar Cliente",
  },
  {
    path: "/clientes/:clientId/animal/novo",
    element: AddPet,
    title: "Novo Animal",
  },
  {
    path: "/clientes/:clientId/animal/:petId/editar",
    element: EditPet,
    title: "Editar Animal",
  },
  {
    path: "/clientes/:clientId/animal/:petId",
    element: PetProfile,
    title: "Perfil do Animal",
  },
];

export default routes;
